module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('section', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.sidebarCurrentPanel === 'steps'),
      expression: "sidebarCurrentPanel === 'steps'"
    }],
    staticClass: "kp-modular-submenu kp-modular-submenu-tab kp-animate-tab-open"
  }, [_c('div', {
    staticClass: "kp-modular-tab pt-page no-fade pt-page-current"
  }, [_c('header', {
    staticClass: "kp-modular-title"
  }, [_vm._v("\n        " + _vm._s(_vm.$t('general.labels.steps')) + "\n      ")]), _vm._v(" "), _c('div', {
    staticClass: "padding-bottom submenu-content"
  }, [_c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.stepHasOnlyThanks),
      expression: "stepHasOnlyThanks"
    }],
    staticClass: "kp-first-component"
  }, [_c('div', {
    staticClass: "kp-first-text"
  }, [_vm._v("\n            " + _vm._s(_vm.$t('general.actions.click')) + " " + _vm._s(_vm.$t('general.labels.in').toUpperCase()) + "\n            "), _vm._m(0), _vm._v("\n            " + _vm._s(_vm.$t('general.labels.to').toUpperCase()) + " "), _c('br'), _vm._v(" " + _vm._s(_vm.$t('general.actions.add')) + " " + _vm._s(_vm.$t('general.labels.your')) + " " + _vm._s(_vm.$t('general.labels.first')) + " " + _vm._s(_vm.$t('general.labels.step')) + "\n          ")])]), _vm._v(" "), _c('list'), _vm._v(" "), _c('button-add')], 1)])]), _vm._v(" "), _c('jump')], 1)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('span', {
    staticClass: "btn_circle btn_circle__text"
  }, [_c('i', {
    staticClass: "kp-panel-plus"
  })])
}]}


/*****************
 ** WEBPACK FOOTER
 ** ./~/vue-loader/lib/template-compiler.js?id=data-v-ddf93d3c!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/edit/sidebar/steps/Main.vue
 ** module id = 916
 ** module chunks = 1
 **/